import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OmniGeralRestService } from '../../omni-rest/omni-geral/omni-geral-rest.service';

@Injectable()
export class ComprovanteRendaService {
  constructor(private _restService: OmniGeralRestService) {}

  getListaTipoComprovanteRenda(): Observable<any> {
    return this._restService.get('tipos-comprovantes-renda').pipe(map(res => res.comprovantes));
  }
}
